module.exports = __webpack_public_path__ + "img/cuco-otimo-full.812aa6b9.svg";